import { ROUTES_SETORES } from '../../../enums';

/**
 * Resolve o slug e o setor correspondentes à rota atual de Empresas.
 *
 * @param {string} pPathname Caminho completo iniciado por `/empresas`.
 * @returns {{route: string, setor: Object|null}} Contexto estável do setor da rota.
 */
export function getEmpresasSetorRouteContext(pPathname) {
  const xRoute = pPathname.split('/')[2];

  return {
    route: xRoute,
    setor: ROUTES_SETORES[xRoute] || null
  };
}
